import React, { useEffect } from 'react';

const GoogleTranslate = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
      function googleTranslateElementInit() {
        new google.translate.TranslateElement({ pageLanguage: 'en',

        layout: google.translate.TranslateElement.InlineLayout.VERTICAL }, 'google_translate_element');
      }
    `;
    document.head.appendChild(script);

    const translateScript = document.createElement('script');
    translateScript.type = 'text/javascript';
    translateScript.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.head.appendChild(translateScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(translateScript);
    };
  }, []);

  return (
    <div id="google_translate_element"></div>
  );
};

export default GoogleTranslate;
